import { render } from "./ContactoContent.vue?vue&type=template&id=7f1d6c2a"
const script = {}

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__